export default __webpack_public_path__ + "static/media/det-aene-am-baergli.50486a21.webp";